import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { loginSuccess, loginFailure } from "../redux/actions";
import { connect } from "react-redux";
import { Card, StyledBody } from "baseui/card";
import { Button } from "baseui/button";
import { Input } from "baseui/input";
import { Block } from "baseui/block";
import Logo from "../../assets/hmlogo.webp";

import { Modal, ModalHeader, ModalBody, ModalFooter } from "baseui/modal";
import { Select } from "baseui/select";
import { FormControl } from "baseui/form-control";

function LogIn({ dispatch }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState(null);
  const [locationsOpen, setLocationsOpen] = useState(false);
  const [locationOptions, setLocationOptions] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [uuid] = useState(null);

  // console.log("process.env.REACT_APP_API_URL", process.env.REACT_APP_API_URL);
  // console.log("Database user:", process.env.DEV_DB_USER);

  const locationsMap = {
    1: "Diberville",
    2: "Douglasville",
    3: "Montgomery",
    4: "Birmingham",
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErrorMessage(null);

    const userCredentials = {
      username,
      password,
      uuid,
    };

    try {
      const response = await axios.post(`${apiUrl}/api/login`, userCredentials);

      if (response.data.success) {
        const token = response.data.token;
        const userData = response.data.user;

        const location_idArray = userData.location_id.map((id) => ({
          id,
          label: locationsMap[id],
        }));

        dispatch(loginSuccess({ user: userData, token }));
        localStorage.setItem("token", token);
        localStorage.setItem("user", JSON.stringify(userData));

        setLocationOptions(location_idArray);

        //if only 1 location object from userData.location_id array
        if (location_idArray.length === 1) {
          // If there's only one location, set it directly and navigate
          setSelectedLocation(location_idArray);
          localStorage.setItem("location", JSON.stringify(location_idArray));

          // Wait until selectedLocation is set, then navigate
          if (location_idArray[0]) {
            //HERE UPDATE STATE.USER.LOGIN_LOCATION w/location_idArray[0].label
            navigate("/dashboard");
          }
        } else {
          setLocationsOpen(true); // Opens the modal for multiple location selection
        }
      } else {
        setErrorMessage(response.data.message || "Login failed.");
        dispatch(loginFailure(response.data.message || "Login failed."));
      }
    } catch (error) {
      console.error("Login error: ", error);
      setErrorMessage(
        "Login failed. Contact your supervisor if you think this is an error."
      );
      dispatch(loginFailure("Login failed"));
    }
  };

  console.log("locationOptions", locationOptions);

  //Modal 'Select Location' functions
  const handleLocationSelect = (params) => {
    setSelectedLocation(params.value);
  };

  const handleLocationConfirm = () => {
    if (selectedLocation.length > 0) {
      localStorage.setItem("location", JSON.stringify(selectedLocation));

      //HERE UPDATE STATE.USER.LOGIN_LOCATION w/location_idArray[0].label
      setLocationsOpen(false); // Close the modal
      navigate("/dashboard");
    } else {
      setErrorMessage("Please select a location.");
    }
  };

  return (
    <Block
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
    >
      <Block width={["30%"]}>
        <Card>
          <Block
            display="flex"
            justifyContent="center"
            alignItems="center"
            padding="scale200"
          >
            <img
              src={Logo}
              style={{ backgroundColor: "white" }}
              className="img-fluid"
              alt="Holmes Motors Logo"
            />
          </Block>
          <StyledBody>
            <h2 style={{ textAlign: "center" }}>Please Login</h2>
            <form onSubmit={handleSubmit}>
              <Block marginBottom="scale600">
                <label htmlFor="username">Username</label>
                <Input
                  id="username"
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="Enter username"
                />
              </Block>
              <Block marginBottom="scale500">
                <label htmlFor="password">Password</label>
                <Input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Password"
                />
              </Block>
              <Button
                type="submit"
                overrides={{ BaseButton: { style: { width: "100%" } } }}
              >
                Login
              </Button>
              {errorMessage && (
                <div style={{ color: "red", textAlign: "center" }}>
                  {errorMessage}
                </div>
              )}
            </form>
            <Block display="flex" justifyContent="center" marginTop="scale500">
              <Link
                to="/admin/forgot-password"
                style={{ textDecoration: "none", color: "#007bff" }}
              >
                Forgot your password?
              </Link>
            </Block>
          </StyledBody>
        </Card>
      </Block>

      {/* Modal for Location Selection */}
      <Modal onClose={() => setLocationsOpen(false)} isOpen={locationsOpen}>
        <ModalHeader>Select Location</ModalHeader>
        <ModalBody>
          <FormControl label="Location">
            <Select
              options={locationOptions}
              value={selectedLocation}
              onChange={handleLocationSelect}
              placeholder="Choose location"
            />
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <Button
            onClick={handleLocationConfirm}
            overrides={{ BaseButton: { style: { width: "100%" } } }}
          >
            Confirm Location
          </Button>
        </ModalFooter>
      </Modal>
    </Block>
  );
}

export default connect()(LogIn);
